var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('total-card'),_c('a-row',{staticStyle:{"margin-top":"24px"},attrs:{"gutter":24}},[_c('a-col',{attrs:{"span":12}},[_c('skill-main-field-card')],1),_c('a-col',{attrs:{"span":12}},[_c('skill-field-card')],1)],1),_c('training-card',{staticStyle:{"margin-top":"24px"}}),_c('up-to-standard-card',{staticStyle:{"margin-top":"24px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }